import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import Details from "./pages/Details";
import Movie from "./pages/movie";
import Series from "./pages/series";
import About from "./pages/About";

import { AuthProvider } from "./contexts/AuthContext";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "details/:mediaType/:id",
    element: <Details />,
  },
  {
    path: "movies",
    element: <Movie />,
  },
  {
    path: "about",
    element: <About />,
  },
  {
    path: "series",
    element: <Series />,
  },
]);

createRoot(document.getElementById("root")).render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);
